import { brandingURL } from '../endpoints';
import BrandingSDK from './branding-sdk';
import * as cache from '../utils/cache';

function BrandingService( { access_token, claims } ) {

    const fetchWithAuth = function( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                'authorization': `Bearer ${ access_token }`
            }
        };

        return fetch( url, options );
    };

    const sdk = new BrandingSDK( brandingURL, fetchWithAuth, cache, claims.company_id );

    return {
        getColors: sdk.getColors,
        upsertColors: sdk.upsertColors,
        getFontFamilies: sdk.getFontFamilies,
        getElements: sdk.getElements,
        getElementProperties: sdk.getElementProperties,
        getStyles: sdk.getStyles,
        upsertStyles: sdk.upsertStyles
    };
}

export default BrandingService;

export const HIERARCHY_TYPES = {
    COMPANY: 'COMPANY',
    SOLUTION: 'SOLUTION',
    EXPERIENCE: 'EXPERIENCE',
    PROGRAM: 'PROGRAM'
};

export const INTENT_TYPES = {
    NONE: 'NONE',
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    INFO: 'INFO',
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    DANGER: 'DANGER'
};

export const ELEMENT_TYPES = {
    BUTTON: 'BUTTON',
    COLOR: 'COLOR',
    DOCUMENT: 'DOCUMENT',
    FOOTER: 'FOOTER',
    HEADER: 'HEADER',
    INTENT: 'INTENT',
    LINK: 'LINK',
    LOGO: 'LOGO'
};

export const STATE_TYPES = {
    NONE: 'NONE',
    HOVER: 'HOVER',
    FOCUS: 'FOCUS',
    ACTIVE: 'ACTIVE',
    VISITED: 'VISITED',
    DISABLED: 'DISABLED'
};

export const PROPERTY_TYPES = {
    COLOR: 'COLOR',
    SIZE: 'SIZE',
    URL: 'URL',
    STRING: 'STRING',
    FONT: 'FONT'
};

export const THEME_IDS = {
    SHARED: null,
    LIGHT: '00000000-0000-0000-0000-000000000001',
    DARK: '00000000-0000-0000-0000-000000000002'
};
